'use client'

import { createContext } from 'react'
import { ReactNode } from 'react'

export type PresentationStyleConfiguration = {
	spacing?: 'loose' | 'tight'
}

export const PresentationContext = createContext<PresentationStyleConfiguration>({
	spacing: 'loose',
})

export type PresentationStyleProps = PresentationStyleConfiguration & {
	children?: ReactNode
}

export function PresentationStyle({ children, ...props }: PresentationStyleProps) {
	return (
		<PresentationContext.Provider value={props}>
			{children}
		</PresentationContext.Provider>
	)
}
